<template>
	<div>
		<div class="card-body">
			<div class="spacer"></div>

			<v-select-2
				v-if="!userData.isCompany"
				:label="'Wypłać z rachunku'"
				:list="sourceAccounts"
				:value="sourceAccountValue"
				@input="
					commisionAndBalanceCheck('setSourceAccountId', $event.value)
				"
			/>

			<v-select-2
				:label="'Na rachunek'"
				:list="accounts"
				:value="accountValue"
				@input="
					commisionAndBalanceCheck(
						'setDestinationAccountId',
						$event.value
					)
				"
			/>

			<div class="position-amount-input">
				<div class="input" style="width: 100%">
					<input
						:class="[{ filled: isFilled() }]"
						:maxlength="11"
						id="PayoutAmount"
						@keyup="commitAmount($event)"
						v-model="userAmmount"
						autocomplete="off"
					/>
					<label for="PayoutAmount">Kwota do wypłaty PLN</label>
				</div>
			</div>
		</div>

		<div class="card-footer">
			<button
				@click.prevent.stop="submitPayout()"
				type="submit"
				class="btn btn-primary"
				:disabled="getDisabledPaymentButton || loadingButton"
			>
				<span v-if="loadingButton" class="loader-button"></span>
				wypłata
			</button>
			<img
				src="images/question.png"
				@mouseover="toggleTooltip(true)"
				@mouseout="toggleTooltip(false)"
				class="question-icon"
			/>
			<span class="commision-info">
				<small>Prowizja:</small>
				<br />
				{{ commision ? commision : '0,00 PLN' }}&nbsp;
			</span>

			<span class="commision-info" v-if="balance">
				<small>Wolne środki:</small>
				<br />
				{{ balance }}&nbsp;
			</span>

			<transition tag="div" name="fade">
				<div class="tooltip" v-if="showTooltip">
					<b>Orientacyjne czasy realizacji wypłat:</b>
					<ul>
						<li>
							<b>Pomiędzy rachunkami OTC:</b> realizacja
							natychmiastowa
						</li>
						<li>
							<b>W ramach Biura maklerskiego mBanku:</b>
							realizacja do 10 minut
						</li>
						<li>
							<b>W ramach Grupy mBanku:</b> 8:00-17:30 (dni
							robocze), realizacja do 45 minut
						</li>
						<li>
							<b>Banki poza Grupą mBanku:</b> w zależności od
							sesji Elixir (BM mBanku obsługuje również III sesję
							Elixir)
						</li>
					</ul>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import { getDictionaryItem } from '@/mixins/get-dictionary-item';
import { mapGetters } from 'vuex';

export default {
	data() {
		return {
			showTooltip: false,
			amountFilled: false,
			correctAmmount: false,
			wrongAmounts: [null, '', '0', '0,', '00', '0,0', '0,00', '0,000'],
			loadingButton: false,
		};
	},
	mixins: [getDictionaryItem],
	methods: {
		async submitPayout() {
			if (this.loadingButton) return;
			this.loadingButton = true;
			try {
				await this.$store.dispatch('postPayout');
			} finally {
				this.loadingButton = false;
			}
		},
		toggleSubmitButton() {
			if (
				this.accountId &&
				this.accountId !== '0' &&
				this.sourceAccountId &&
				this.correctAmmount &&
				this.accountId != this.sourceAccountId &&
				this.getCurrentAmmount
			) {
				this.$store.commit('setDisabledPaymentButton', false);
			} else {
				this.$store.commit('setDisabledPaymentButton', true);
			}
		},
		toggleTooltip(show) {
			this.showTooltip = show;
		},

		commisionAndBalanceCheck(setterName, value) {
			this.$store.commit(setterName, value);
			this.$store.dispatch('fetchCommision');
			this.$store.dispatch('fetchBalance');
		},
		commitAmount(e) {
			let currencyAmount = e.target.value
					.replace('.', ',')
					.replace(/([^0-9,.])/g, ''),
				comaIndex = currencyAmount.indexOf(','),
				comaCount = (currencyAmount.match(/,/g) || []).length;

			if (comaCount === 1) {
				currencyAmount = currencyAmount.slice(0, comaIndex + 3);
			} else if (comaCount > 1) {
				currencyAmount = currencyAmount.slice(
					0,
					currencyAmount.lastIndexOf(',')
				);
			}

			this.$store.commit('setPayoutAmount', currencyAmount);
			this.$store.commit('setCurrentAmmount', currencyAmount);
			this.isFilled();

			if (
				!this.wrongAmounts.includes(currencyAmount) &&
				Number(currencyAmount) !== 0 &&
				!currencyAmount.startsWith(',')
			) {
				this.correctAmmount = true;
				this.$store.commit('setDisplayFormFastPayment', false);
				this.$store.commit('setDisplayFormPayout', true);
				this.$store.commit('setDisplayFormAccounts', false);
				this.$store.dispatch('fetchCommision');
				this.$store.dispatch('fetchBalance');
			} else this.correctAmmount = false;
		},
		isFilled() {
			if (
				this.$store.getters.getCurrentAmmount &&
				this.$store.getters.getCurrentAmmount.length > 0
			)
				return true;
			else return false;
		},
	},
	computed: {
		...mapGetters(['getDisabledPaymentButton', 'getCurrentAmmount']),
		accounts() {
			return this.$store.getters.getPayout
				? this.$store.getters.getPayout.accounts
				: [];
		},
		sourceAccounts() {
			return this.$store.getters.getPayout
				? this.$store.getters.getPayout.sourceAccounts
					? this.$store.getters.getPayout.sourceAccounts
					: []
				: [];
		},

		commision: {
			get() {
				return this.$store.getters.getCommision || '';
			},
		},
		balance: {
			get() {
				return this.$store.getters.getBalance
					? this.$store.getters.getBalance
					: '';
			},
		},
		accountId: {
			get() {
				return this.$store.getters.getPayout
					? this.$store.getters.getPayout.destinationAccountId
					: false;
			},
			set(value) {
				this.$store.commit('setDestinationAccountId', value);
			},
		},
		accountValue() {
			return this.getDictionaryItem(
				this.accounts,
				'text',
				'value',
				this.accountId
			);
		},
		sourceAccountId: {
			get() {
				return this.$store.getters.getPayout
					? this.$store.getters.getPayout.sourceAccountId
					: false;
			},
			set(value) {
				this.$store.commit('setSourceAccountId', value);
			},
		},
		sourceAccountValue() {
			return this.getDictionaryItem(
				this.sourceAccounts,
				'text',
				'value',
				this.sourceAccountId
			);
		},
		userData() {
			return this.$store.getters.getUser
				? this.$store.getters.getUser
				: false;
		},
		payout() {
			return this.$store.getters.getPayout
				? this.$store.getters.getPayout
				: false;
		},
		userAmmount: {
			get() {
				return this.$store.getters.getCurrentAmmount;
			},
			set(value) {
				this.$store.commit('setCurrentAmmount', value);
			},
		},
	},
	watch: {
		correctAmmount(newVal, oldVal) {
			if (newVal !== oldVal) {
				// this.checkCommision();
				// this.checkBalance();
				this.toggleSubmitButton();
			}
		},
	},
	beforeMount() {
		this.toggleSubmitButton();
	},
	updated() {
		if (this.payout) {
			this.toggleSubmitButton();
		}
	},
	mounted() {
		this.isFilled();
		this.$store.commit('setCurrentAmmount', '');
		if (this.$store.getters.getPayout) {
			this.$store.commit('setDestinationAccountId', 0);
			!this.userData.isCompany
				? this.$store.commit('setSourceAccountId', '')
				: '';
			// this.$store.commit("setSourceAccountId", "");
			this.$store.commit('setPayoutAmount', '');
		}
		this.$store.commit('setBalance', '');
		this.$store.commit('setCommision', '');
	},
};
</script>

<style></style>
